import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';


const DownloadFiles20 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial20/tutorial20.zip?ref_type=heads&inline=false', download: 'tutorial20.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialTwenty= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Add and Delete Items from ListWidget Using Button with Qt Designer, PyQt6, and Python</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/A_s5D-k6evo/maxresdefault.jpg"
                            alt="Tutorial 20"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this step-by-step tutorial, you'll learn how to add and delete items from a QListWidget using buttons in PyQt6, with the help of Qt Designer for building the GUI. This hands-on guide will show you how to design the interface, connect signals, and implement item management in a pythonic and beginner-friendly way.
                        <br /><strong>What you'll learn:</strong>
                        <ul>
                            <li>Setting up a PyQt6 project</li>
                            <li>Designing a simple GUI with Qt Designer</li>
                            <li>Connecting buttons to add and remove items in a QListWidget</li>
                            <li>Writing clean and maintainable Python code for list operations</li>
                            <li>Testing and improving the application</li>
                        </ul>
                        This tutorial is perfect for both beginners exploring PyQt6 and experienced developers who want to practice efficient list management in GUI applications.
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #ListWidget #AddDeleteItems #DesktopApps #Programming #GUI
                    </p>

                    <button className="seemore">
                        <DownloadFiles20 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialTwenty;
